import React from 'react'
import SearchBar from "../Search/SearchBar"
const UpdateSearch = () => {
    return (
        <SearchBar />
    )
}

export default UpdateSearch
